import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/codeforcause123'
      className='link footer__link'
    >
      Created By Aayush
    </a>
  </footer>
)

export default Footer
